import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const TESTIMONIALS = [
  {
    name: "Amina L.",
    initials: "AL",
    tag: "Guide mémorisation",
    text: "J'ai enfin un plan clair. En trois mois, j'ai mémorisé plus qu'en deux ans toute seule. Le suivi jour par jour change absolument tout.",
  },
  {
    name: "Idriss M.",
    initials: "IM",
    tag: "Pack Gold",
    text: "Le pack m'a évité de chercher des méthodes partout. J'ai mémorisé pendant 6 mois, puis la révision de 30 jours a tout ancré. Parcours impeccable.",
  },
  {
    name: "Yasmine B.",
    initials: "YB",
    tag: "Guide révision",
    text: "Je pensais avoir une mauvaise mémoire. En réalité, je n'avais simplement pas de méthode de révision. Trente jours plus tard, tout est stable.",
  },
  {
    name: "Sarah K.",
    initials: "SK",
    tag: "Guide mémorisation",
    text: "Vingt minutes par jour avec trois enfants, et j'avance chaque semaine. Le planning est réaliste — c'est exactement ce qui fait la différence.",
  },
];

const EASE = [0.16, 1, 0.3, 1];

const initialsOf = (name) =>
  name.split(/\s+/).map((w) => w[0]).join("").slice(0, 2).toUpperCase();

export default function Testimonials() {
  const [items, setItems] = useState(TESTIMONIALS);

  useEffect(() => {
    fetch(`${API}/api/testimonials`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d?.testimonials?.length) setItems(d.testimonials);
      })
      .catch(() => {});
  }, []);

  return (
    <section id="avis" className="testimonials" data-testid="testimonials-section">
      <div className="container">
        <motion.div
          className="section-head"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
        >
          <div className="eyebrow">Ils l'ont fait</div>
          <h2>Ils ont transformé leur relation au Coran</h2>
          <p>Des lectrices et lecteurs de tous niveaux suivent la méthode, chacun à son rythme.</p>
        </motion.div>

        <div className="t-grid">
          {items.map((t, i) => (
            <motion.article
              key={t.id || t.name}
              className="t-card"
              initial={{ opacity: 0, y: 44 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.85, delay: i * 0.1, ease: EASE }}
              data-testid={`testimonial-card-${i}`}
            >
              <div className="t-stars" aria-label="5 étoiles sur 5">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star key={s} size={15} fill="var(--gold)" color="var(--gold)" />
                ))}
              </div>
              <p className="t-text">«&nbsp;{t.text}&nbsp;»</p>
              <div className="t-who">
                <span className="t-avatar" aria-hidden="true">{t.initials || initialsOf(t.name)}</span>
                <span>
                  <span className="t-name">{t.name}</span>
                  <span className="t-tag">{t.tag}</span>
                </span>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
